module.exports = __webpack_public_path__ + "static/media/Logout.5b43e64f.svg";